// JS file for Register

import '@main';

u.$ui.tomSelect('.j-model-select', {
  maxOptions: 99999
});
u.$ui.flatpickr();

$('.j-serial').focus();

const serialInput = $('.j-serial');
const modelInput = $('.c-model-input--input');
const modelSelect = $('.c-model-input--select');

serialInput.blur(function (e) {
  $('.j-model-name').attr('disabled', false);
  loadHardware($(e.currentTarget));
});
$('.j-model-name').on('blur', (e) => {
  loadHardware($(e.currentTarget));
});

loadHardware($('.j-serial'));

function loadHardware($input) {
  if ($input.val() === '') {
    showInput();
    return;
  }

  if (serialInput.val().toUpperCase().startsWith('SN')) {
    serialInput.val(serialInput.val().substring(2));
  }

  return u.$http.get(`@ajax_hardware_validate/?serial=${serialInput.val()}&model=${$('.j-model-name').val()}`)
    .then(function (response) {
      const data = response.data.data;

      if (data.select) {
        showSelect();
      } else {
        showInput();

        if (data.model) {
          $('.j-model-name').val(data.model);

          if (data.lock) {
            $('.j-model-name').attr('disabled', true);
          }
        }
      }

      if (data.file) {
        $('.j-file-download').removeClass('d-none');
        $('.j-file-download').children('a').attr('href', data.file);
      } else {
        $('.j-file-download').addClass('d-none');
      }
    })
    .catch(function (e) {
      const response = e.response.data.message;
      $('.j-model-name').val('');

      swal({
        title: response,
        button: {
          text: 'close',
          class: 'btn btn-primary'
        }
      });
    });
}

function showSelect() {
  modelInput.find('input').attr('disabled', true);
  modelSelect.find('select').attr('disabled', false);
  modelInput.hide();
  modelSelect.show();

  modelSelect.find('select')[0].tomselect?.enable();
}

function showInput() {
  modelInput.find('input').attr('disabled', false);
  modelSelect.find('select').attr('disabled', true);
  modelInput.show();
  modelSelect.hide();

  modelSelect.find('select')[0].tomselect?.disable();
}

// Force disable input or select
window.submitForm = (button) => {
  $('#admin-form .form-group').find('input,select').filter(':hidden')
    .attr('required', false)
    .attr('disabled', true);

  const form = $('#admin-form')[0];
  const $button = $(button);



  if (form.checkValidity()) {
    $button.attr('disabled', true);
    $button.find('span').show();

    form.requestSubmit();
  } else {
    form.reportValidity();
  }

  // setTimeout(() => {
  //
  //
  //   $button.attr('disabled', false);
  //   $button.find('span').hide();
  // });
};
